import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface Promotion {
  id: string;
  name: string;
  discount_type: 'percentage' | 'fixed';
  discount_value: number;
  is_active: boolean;
}

export const checkProductPromotion = async (
  productId: string,
  selectedCustomerId?: string
): Promise<Promotion | null> => {
  try {
    // Check for customer-specific promotions first
    if (selectedCustomerId) {
      const { data: customerPromotion, error: customerError } = await supabase
        .from('promotions')
        .select('*')
        .eq('customer_id', selectedCustomerId)
        .eq('is_active', true)
        .lte('start_date', new Date().toISOString())
        .gte('end_date', new Date().toISOString())
        .maybeSingle();

      if (customerError) throw customerError;
      if (customerPromotion) return customerPromotion;
    }

    // Then check for standard promotions
    const { data: standardPromotions, error: standardError } = await supabase
      .from('promotions')
      .select('*')
      .is('customer_id', null)
      .eq('is_active', true)
      .lte('start_date', new Date().toISOString())
      .gte('end_date', new Date().toISOString())
      .maybeSingle();

    if (standardError) throw standardError;
    if (!standardPromotions) return null;

    // Verify product association with promotion
    const { data: promotionProduct, error: promotionProductError } = await supabase
      .from('promotion_products')
      .select('*')
      .eq('promotion_id', standardPromotions.id)
      .eq('stock_item_id', productId)
      .single();

    if (promotionProductError) throw promotionProductError;
    
    return promotionProduct ? standardPromotions : null;
  } catch (error) {
    console.error("Erreur lors de la vérification des promotions:", error);
    return null;
  }
};

export const displayPromotionToast = (promotion: Promotion) => {
  toast.info(
    `Une promotion de ${promotion.discount_value}${
      promotion.discount_type === 'percentage' ? '%' : ' FCFA'
    } est appliquée à ce produit`
  );
};